// Constants
import {
  BILLING_DETAILS_ADDRESS,
  REDIRECT_REQUIRED,
} from '../../constants/payment-landing-form.constants';
// Enums
import { CheckPaymentStatusEnum } from './enumerations/payment-landing-form.handlers.utils.enumeration';
// Types
import {
  ConfirmPaymentType,
  CreatePaymentMethodType,
  GetBillingDetailsType,
  SubmitElementsType,
} from './types/payment-landing-form.handlers.utils.type';
import { PaymentMethod } from '@stripe/stripe-js';

const getBillingDetails = (cardCountry: string): GetBillingDetailsType => ({
  billing_details: {
    address: { ...BILLING_DETAILS_ADDRESS, country: cardCountry },
  },
});

const confirmPayment = async ({
  cardCountry,
  elements,
  paymentMethodId,
  stripe,
  handleGetOnboardingStateEvent,
}: ConfirmPaymentType): Promise<any> => {
  const { error, paymentIntent } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      payment_method_data: { ...getBillingDetails(cardCountry) },
      payment_method: paymentMethodId,
    },
    redirect: REDIRECT_REQUIRED,
  });

  if (error && !paymentIntent) {
    console.error('Error confirming payment:', error);
    return true;
  }

  handleGetOnboardingStateEvent();
};

const createPaymentMethod = async ({
  cardCountry,
  elements,
  stripe,
}: CreatePaymentMethodType): Promise<PaymentMethod | null> => {
  const { error, paymentMethod } = await stripe.createPaymentMethod({
    elements,
    params: {
      ...getBillingDetails(cardCountry),
    },
  });

  if (error || !paymentMethod) {
    return null;
  }
  return paymentMethod;
};

const submitElements = async ({ elements }: SubmitElementsType): Promise<boolean> => {
  const { error } = await elements.submit();
  if (error) {
    return true;
  }
  return false;
};

const checkValidOperation = (status: CheckPaymentStatusEnum | undefined): boolean =>
  status !== undefined && status === CheckPaymentStatusEnum.VALID;

export {
  confirmPayment,
  createPaymentMethod,
  getBillingDetails,
  submitElements,
  checkValidOperation,
};
